import { UserbotCatalog } from "../../interfaces"
import { isValidJson, isBlank } from "../common/jsonUtils"

const asString = (v: unknown): string | undefined =>
  v === undefined || v === null ? undefined : String(v)

/** Whole-string плейсхолдер: {{...}} (TEMPLATE_RE из TZ §2.3). */
const isPlaceholder = (v: string): boolean => /^\{\{[\s\S]+\}\}$/.test(v)

/** Проверяет required-поля внутри object-спеки. */
const validateObjectFields = (
  fields: UserbotCatalog.FieldSpec[],
  value: unknown,
): string | null => {
  const obj = (value ?? {}) as Record<string, unknown>
  for (const f of fields) {
    if (!f.required) continue
    const raw = obj[f.key]
    const empty =
      f.type === "array"
        ? !Array.isArray(raw) || raw.length === 0
        : isBlank(asString(raw))
    if (empty) {
      return `Поле «${f.label}» обязательно`
    }
  }
  return null
}

/** Возвращает map ключ→сообщение об ошибке (пустой = валидно). */
export const validateFieldValues = (
  specs: UserbotCatalog.FieldSpec[],
  values: Record<string, unknown>,
): Record<string, string> => {
  const errors: Record<string, string> = {}
  for (const spec of specs) {
    const raw = values[spec.key]
    const empty =
      spec.type === "array"
        ? !Array.isArray(raw) || raw.length === 0
        : spec.type === "object"
          ? !raw || typeof raw !== "object"
          : spec.type === "oneOf"
            ? isBlank(asString(raw))
            : isBlank(asString(raw))

    if (spec.required && empty) {
      errors[spec.key] = `Поле «${spec.label}» обязательно`
      continue
    }

    // Не-templatable поле не принимает whole-string {{...}}
    if (!spec.templatable && !empty) {
      const s = asString(raw)
      if (s && isPlaceholder(s)) {
        errors[spec.key] = `Поле «${spec.label}» не поддерживает плейсхолдер`
        continue
      }
    }

    if (spec.type === "json" && !empty && !isValidJson(asString(raw))) {
      errors[spec.key] = `Поле «${spec.label}» — некорректный JSON`
      continue
    }

    // Рекурсивная валидация для object
    if (spec.type === "object" && !empty && spec.fields) {
      const subError = validateObjectFields(spec.fields, raw)
      if (subError) {
        errors[spec.key] = subError
      }
    }
  }
  return errors
}
